/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-09T10:02:22+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-20T13:39:42+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import buttonProps from './../../../utilities/buttonProps';
import AIconInline, {SMALL} from './../../icons/components/AIconInline';

/**
 * AButtonIconInput - …
**/
class AButtonIconInput extends Component {
  render() {
    const {
      onPress,
      icon,
      visualState,
      active, // eslint-disable-line no-unused-vars
      ...other
    } = this.props;
    return (
      <button
        {...other}
        className={`a-button a-button-icon-input ${visualState}`}
        onClick={onPress}
      >
        <AIconInline
          icon={icon}
          size={SMALL}
        />
      </button>
    );
  }
}
AButtonIconInput.propTypes = {
  icon: PropTypes.string,
  onPress: PropTypes.func,
  active: PropTypes.bool,
  visualState: PropTypes.string,
};
AButtonIconInput.defaultProps = {
  icon: 'calendar',
};
export default buttonProps(AButtonIconInput);

